import {Form} from "./form";

let form;

const initForm = () => {
  form = new Form();

  window.form = form;
  form.init();
};

export {form, initForm};
